import React, { Suspense } from 'react';
import { withRouter, Redirect, Route, Switch } from 'react-router-dom';

import Main from './Main';
import { Loading } from 'Components/Partials/Layouts';

import PostAuthRoutes from 'Config/Routes/PostAuthRoutes';
import { Scopes } from 'Services';

class AuthenticatedRouter extends Main {
    /**
     * @method shouldComponentUpdate
     * @param {object} nextProps
     * @returns {boolean}
     */
    shouldComponentUpdate = (nextProps) => {
        return this.props.location.pathname !== nextProps.location.pathname;
    };

    /**
     * @method componentDidUpdate
     */
    componentDidUpdate = () => {
        if (this.props.user?.password_needs_updating && this.props.location.pathname !== '/settings/security/force') {
            this.props.history.push('/settings/security/force');

            return;
        }
    };

    /**
     * @method render
     * @return {*}
     */
    render = () => {
        return (
            <Suspense fallback={ (<Loading/>) }>
                <Switch>
                    { PostAuthRoutes.map((props) => this.renderRoute(props)) }

                    { Scopes.has('dashboard.*') && (
                        <Route path="/">
                            <Redirect to="/dashboard"/>
                        </Route>
                    ) }

                    { Scopes.has('below-zero.*') && (
                        <Route path="/">
                            <Redirect to="/below-zero/diary"/>
                        </Route>
                    ) }
                </Switch>
            </Suspense>
        );
    };
}

export default withRouter(AuthenticatedRouter);
